import * as React from 'react';
import { EmptyState } from '@brightlayer-ui/react-components';
import { Icon, getIcon } from '../../lib/icons';
import { RecordData, RecordDataState } from '../../hooks/data-hooks';
import { CenteredContent } from '../CenteredContent';

export const RecordDataNotFoundIndicator: React.FC<{
    icon: Icon;
    message: string;
    recordData: RecordData;
}> = (props) => {
    if (props.recordData.state !== RecordDataState.NotFound) {
        return null;
    }

    const TheIcon = getIcon(props.icon);

    return (
        <CenteredContent>
            <EmptyState
                icon={<div style={{ fontSize: 64 }}>{TheIcon && <TheIcon id="fail-icon" fontSize="inherit" />}</div>}
                title={props.message}
            />
        </CenteredContent>
    );
};
